module.exports = __webpack_public_path__ + "img/choose-background-img.ac41ed45.png";